function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
    let quantityInput = event.target;
    if (quantityInput) {
        setTimeout(function() {
            let priceElement = document.querySelector(".salepricemainecustom");
            let regularPriceElement = document.querySelector(".regularpricecustom");
            let atcPriceElement = document.querySelector(".main-atc-price"); // Check if this class is present
            function updatePrice(element) {
                if (element) {
                    let priceText = element.getAttribute("data-val")?.trim(); // Get price from data-val
                    let currencySymbol = priceText.match(/[^\d.]/g)?.join('') || ''; // Extract currency symbol
                    let price = parseFloat(priceText.replace(/[^0-9.]/g, "")); // Extract only numeric value
                    let quantity = parseInt(quantityInput.value) || 1; // Ensure quantity is valid
    
                    if (!isNaN(price)) {
                        let multipliedPrice = price * quantity;
                        element.textContent = currencySymbol + multipliedPrice.toFixed(2); // Update with currency
                    }
                }
            }
    
            updatePrice(regularPriceElement);
            updatePrice(priceElement);
            if (atcPriceElement) {
              updatePrice(atcPriceElement);
            }
    
        }, 200);
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      // setTimeout(() => {
      //   detailsElement.classList.add('menu-opening');
      //   summaryElement.setAttribute('aria-expanded', true);
      //   parentMenuElement && parentMenuElement.classList.add('submenu-open');
      //   !reducedMotion || reducedMotion.matches
      //     ? addTrapFocus()
      //     : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      // }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      //this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

// function _0x1416(){const _0x47793a=['yMVZR','JLX','addEventLi','dating\x20tok','eHuul','origin','uZcnP','wHIxQ','hzxFs','ease\x20try\x20a','rFphk','error','cYljR','27tvadoX','VJiOz','DQLyF','mXZDt','ZEwgW','Token\x20is\x20v','keydown','SIAlT','bMgHI','qmzBw','ById','CRQFQ','GjycG','shiftKey','SkqoN','getElement','yRJqE','793420ecoVJB','lSPQL','key','xLFBC','vKPIg','FeNXe','Hbivf','fCxru','DhQrw','ajrla','nUInh','\x20\x20\x20\x20\x20\x20\x20\x20','POST','JpgPy','bHqVy','1383852VdMyLQ','qaMwf','34800XhNqTH','shift','body','413srsAWb','stringify','shopifypre','1607664qMBEed','6HpcSAz','AxgSs','895dpOYij','applicatio','https://','PDifi','iconSize','ORKuf','NKvLs','3736qMWTud','22LMTVHz','IRSaY','en:','cIOSI','innerHTML','FgPpP','qZxOc','MSgbS','ault','gYNzE','327984wpCQjw','shop','vKHBx','n/json','.</p>\x0a\x20\x20\x20\x20','jroXE','Shopify','dDRgX','uwHms','IPYTP','HzRMf','ctrlKey','wlIro','gJBcO','Ampzx','alid.','CUGmS','CkrUR','220705bIRY','includes','4389bDCRDE','DOMContent','\x20token.\x20Pl','UUZfu','oKnCR','YFmpv','gNPaO','LjANb','QXDXQ','DrKhB','uFcVv','ZUPjr','F12','KIrnX','json','JHUfs','482332hBKv','qGkeV','1127903qxO','LgOGU','preventDef','5046kRlGdS','jjHfq','log','HAEDv','228334njnE','tLhtN','TxBaY','HHWIM','QznNi','view.com','wqasV','evpPO','gain\x20later','52660CnBdKf','dataset','valid','Dzquj','HOVpY','theme-data','PgiPH','location','mENEf','btfZR','144xCXwcH','111032tCQP','contextmen','xLNrb','push','275WjrycO','xRFrG','then','oINlf','jUbqV','catch','\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20','\x20\x20\x20\x20\x20\x20\x20<p>','DLdxB','ZSenS','NNBgO','stener','WEpOj','zZmwM','Ucvrp','dating\x20the','XSKSp','DdKAv','Error\x20vali','Ascva','join','45uRMSsn','xZPUo','BRwvY','YMwlU','wVxDW','wfRvR','Hlufr','5710rAkSvP','seFzp','zpqkc','rtfQD','Loaded'];_0x1416=function(){return _0x47793a;};return _0x1416();}(function(_0x375357,_0x55db58){const _0x15794d=_0x1ba2,_0x1435a4=_0x375357();while(!![]){try{const _0x537cd4=parseInt(_0x15794d(0x199))/(0x8fa+0x2e*0x6f+0xb*-0x2a1)*(parseInt(_0x15794d(0x1f9))/(0x22db+0x87b+-0x2b54))+parseInt(_0x15794d(0x204))/(-0x1a*0x3f+0x238d*-0x1+0x14fb*0x2)+parseInt(_0x15794d(0x1e7))/(0xd*-0xb7+-0xbf*-0x1+0x890)+parseInt(_0x15794d(0x18a))/(-0x1a*0x129+0x1*0xb3e+0x1*0x12f1)*(parseInt(_0x15794d(0x194))/(-0x1*-0x1777+0x288+-0x6d*0x3d))+parseInt(_0x15794d(0x1ec))/(-0x11ee+-0x595+0x178a)*(-parseInt(_0x15794d(0x1e9))/(-0x11*0xf+-0x175c+0x1863))+parseInt(_0x15794d(0x1ae))/(-0xb*0x161+-0x1d*-0x147+-0x1*0x15d7)*(-parseInt(_0x15794d(0x1d8))/(0xd8+-0x67f*-0x1+-0x74d))+-parseInt(_0x15794d(0x1fa))/(-0x53*-0x3a+-0x1*-0xf4+-0x7*0x2d1)*(parseInt(_0x15794d(0x1ef))/(-0x1660+0xc2*-0x17+0x27da));if(_0x537cd4===_0x55db58)break;else _0x1435a4['push'](_0x1435a4['shift']());}catch(_0x46ed55){_0x1435a4['push'](_0x1435a4['shift']());}}}(_0x1416,0x7fd08+0x8e316+-0xc4a77));function _0x1ba2(_0x1be4d6,_0x449193){const _0x74fe8a=_0x1416();return _0x1ba2=function(_0x3b23fe,_0x1d4e8d){_0x3b23fe=_0x3b23fe-(0x14b2+0x20ac+-0x33fa);let _0x213875=_0x74fe8a[_0x3b23fe];return _0x213875;},_0x1ba2(_0x1be4d6,_0x449193);}function _0x42f0(){const _0x50ece6=_0x1ba2,_0x2da45a={'GjycG':_0x50ece6(0x20f),'uFcVv':_0x50ece6(0x195)+'cb','qGkeV':_0x50ece6(0x17f),'PDifi':_0x50ece6(0x174),'jroXE':_0x50ece6(0x167),'IPYTP':_0x50ece6(0x1ad),'CkrUR':_0x50ece6(0x1bf),'wfRvR':_0x50ece6(0x1eb),'rtfQD':_0x50ece6(0x17d),'KIrnX':_0x50ece6(0x168),'DLdxB':_0x50ece6(0x1f0),'yMVZR':_0x50ece6(0x205),'UUZfu':_0x50ece6(0x1c5),'fCxru':_0x50ece6(0x196)+'u','IRSaY':_0x50ece6(0x1f2),'wqasV':_0x50ece6(0x1ed),'yRJqE':_0x50ece6(0x178)+'QP','vKPIg':_0x50ece6(0x19e),'dDRgX':_0x50ece6(0x1cc)+_0x50ece6(0x213),'CRQFQ':_0x50ece6(0x1b5),'YFmpv':_0x50ece6(0x1d4),'DdKAv':_0x50ece6(0x1f3)+_0x50ece6(0x207),'wVxDW':_0x50ece6(0x1c7),'zpqkc':_0x50ece6(0x17a)+_0x50ece6(0x1bb),'tLhtN':_0x50ece6(0x1d6)+_0x50ece6(0x1d1),'DQLyF':_0x50ece6(0x1fe),'LgOGU':_0x50ece6(0x19b),'gJBcO':_0x50ece6(0x1ee)+_0x50ece6(0x186),'gNPaO':_0x50ece6(0x191),'FeNXe':_0x50ece6(0x1bc)+_0x50ece6(0x1a4),'JHUfs':_0x50ece6(0x17c)+_0x50ece6(0x202),'TxBaY':_0x50ece6(0x169)+_0x50ece6(0x1b9),'oKnCR':_0x50ece6(0x176),'QXDXQ':_0x50ece6(0x20a),'bHqVy':_0x50ece6(0x18b),'cYljR':_0x50ece6(0x1da),'AxgSs':_0x50ece6(0x181)+'fv','HHWIM':_0x50ece6(0x166)+'gI','btfZR':_0x50ece6(0x1e4),'rFphk':_0x50ece6(0x1cd),'Hbivf':function(_0x15440e){return _0x15440e();}},_0x3a4ba0=[_0x2da45a[_0x50ece6(0x1d3)],_0x2da45a[_0x50ece6(0x172)],_0x2da45a[_0x50ece6(0x179)],_0x2da45a[_0x50ece6(0x1f5)],_0x2da45a[_0x50ece6(0x209)],_0x2da45a[_0x50ece6(0x20d)],_0x2da45a[_0x50ece6(0x165)],_0x2da45a[_0x50ece6(0x1b3)],_0x2da45a[_0x50ece6(0x1b8)],_0x2da45a[_0x50ece6(0x175)],_0x2da45a[_0x50ece6(0x1a1)],_0x2da45a[_0x50ece6(0x1ba)],_0x2da45a[_0x50ece6(0x16b)],_0x2da45a[_0x50ece6(0x1df)],_0x2da45a[_0x50ece6(0x1fb)],_0x2da45a[_0x50ece6(0x187)],_0x2da45a[_0x50ece6(0x1d7)],_0x2da45a[_0x50ece6(0x1dc)],_0x2da45a[_0x50ece6(0x20b)],_0x2da45a[_0x50ece6(0x1d2)],_0x2da45a[_0x50ece6(0x16d)],_0x2da45a[_0x50ece6(0x1aa)],_0x2da45a[_0x50ece6(0x1b2)],_0x2da45a[_0x50ece6(0x1b7)],_0x2da45a[_0x50ece6(0x182)],_0x2da45a[_0x50ece6(0x1c9)],_0x2da45a[_0x50ece6(0x17b)],_0x2da45a[_0x50ece6(0x211)],_0x2da45a[_0x50ece6(0x16e)],_0x2da45a[_0x50ece6(0x1dd)],_0x2da45a[_0x50ece6(0x177)],_0x2da45a[_0x50ece6(0x183)],_0x2da45a[_0x50ece6(0x16c)],_0x2da45a[_0x50ece6(0x170)],_0x2da45a[_0x50ece6(0x1e6)],_0x2da45a[_0x50ece6(0x1c6)],_0x2da45a[_0x50ece6(0x1f1)],_0x2da45a[_0x50ece6(0x184)],_0x2da45a[_0x50ece6(0x193)],_0x2da45a[_0x50ece6(0x1c4)]];return _0x42f0=function(){return _0x3a4ba0;},_0x2da45a[_0x50ece6(0x1de)](_0x42f0);}const _0x4c5d07=_0x32ae;function _0x32ae(_0x2836d,_0x2094f0){const _0x55ee19=_0x1ba2,_0x31c93e={'cIOSI':function(_0x5e7090,_0xc8ccd2){return _0x5e7090-_0xc8ccd2;},'mXZDt':function(_0x5d92c3){return _0x5d92c3();},'PgiPH':function(_0x435902,_0x5baef1,_0x4f3967){return _0x435902(_0x5baef1,_0x4f3967);}},_0x121da4=_0x31c93e[_0x55ee19(0x1ca)](_0x42f0);return _0x32ae=function(_0x534365,_0x438d6e){const _0x4ba51d=_0x55ee19;_0x534365=_0x31c93e[_0x4ba51d(0x1fd)](_0x534365,-0x7f3+-0x2*0xf1+-0xb52*-0x1);let _0x51ce1d=_0x121da4[_0x534365];return _0x51ce1d;},_0x31c93e[_0x55ee19(0x190)](_0x32ae,_0x2836d,_0x2094f0);}(function(_0x446cc3,_0x59d02b){const _0x41f4fc=_0x1ba2,_0x212ce4={'uZcnP':function(_0x121d10){return _0x121d10();},'DrKhB':function(_0xf9d5a,_0x377c8a){return _0xf9d5a+_0x377c8a;},'FgPpP':function(_0x58c692,_0x208ea9){return _0x58c692+_0x208ea9;},'LjANb':function(_0x45a473,_0x2b4dcc){return _0x45a473+_0x2b4dcc;},'lSPQL':function(_0x4af53b,_0x25924c){return _0x4af53b+_0x25924c;},'HAEDv':function(_0x46166b,_0x3c5b7d){return _0x46166b+_0x3c5b7d;},'ORKuf':function(_0x1103f4,_0xd1391f){return _0x1103f4/_0xd1391f;},'VJiOz':function(_0x55d1a0,_0x4cb9c0){return _0x55d1a0(_0x4cb9c0);},'xLFBC':function(_0x58b272,_0x5a8d3e){return _0x58b272(_0x5a8d3e);},'jjHfq':function(_0x5c053f,_0x1f2495){return _0x5c053f(_0x1f2495);},'Dzquj':function(_0x460995,_0x4964fd){return _0x460995*_0x4964fd;},'qmzBw':function(_0x29580d,_0x52098d){return _0x29580d/_0x52098d;},'HzRMf':function(_0x49029d,_0x53a18d){return _0x49029d(_0x53a18d);},'BRwvY':function(_0x1a1651,_0x3df908){return _0x1a1651(_0x3df908);},'xRFrG':function(_0x5961bf,_0x361079){return _0x5961bf*_0x361079;},'HOVpY':function(_0x225f9e,_0x2d5e74){return _0x225f9e(_0x2d5e74);},'wlIro':function(_0x59f0cc,_0x4c71f9){return _0x59f0cc/_0x4c71f9;},'ZUPjr':function(_0x3d7f3e,_0x4bad8d){return _0x3d7f3e(_0x4bad8d);},'Ucvrp':function(_0xe093ec,_0x11a05a){return _0xe093ec/_0x11a05a;},'wHIxQ':function(_0x1556c0,_0x15f705){return _0x1556c0(_0x15f705);},'qZxOc':function(_0x314c70,_0x87ce98){return _0x314c70(_0x87ce98);},'bMgHI':function(_0x3b5832,_0x19ef96){return _0x3b5832(_0x19ef96);},'eHuul':function(_0x2514a2,_0x39f09a){return _0x2514a2(_0x39f09a);},'xLNrb':function(_0x5785a7,_0x3027e3){return _0x5785a7/_0x3027e3;},'hzxFs':function(_0x1ffbfd,_0x2f146f){return _0x1ffbfd(_0x2f146f);},'CUGmS':function(_0x3c6cb9,_0x33cb2f){return _0x3c6cb9/_0x33cb2f;},'Ampzx':function(_0x48b773,_0x510deb){return _0x48b773(_0x510deb);},'ajrla':function(_0x2c7b22,_0x1576e2){return _0x2c7b22(_0x1576e2);},'evpPO':function(_0x19ebf4,_0x202c1f){return _0x19ebf4===_0x202c1f;},'Hlufr':_0x41f4fc(0x198),'vKHBx':_0x41f4fc(0x1ea)},_0x40957d=_0x32ae,_0x5d77cb=_0x212ce4[_0x41f4fc(0x1c0)](_0x446cc3);while(!![]){try{const _0x118082=_0x212ce4[_0x41f4fc(0x171)](_0x212ce4[_0x41f4fc(0x171)](_0x212ce4[_0x41f4fc(0x1ff)](_0x212ce4[_0x41f4fc(0x16f)](_0x212ce4[_0x41f4fc(0x1d9)](_0x212ce4[_0x41f4fc(0x180)](_0x212ce4[_0x41f4fc(0x1f7)](_0x212ce4[_0x41f4fc(0x1c8)](parseInt,_0x212ce4[_0x41f4fc(0x1c8)](_0x40957d,0x19d6*-0x1+-0xdd+0x1c4f)),-0x10f2+-0x1*-0x122c+0x139*-0x1),_0x212ce4[_0x41f4fc(0x1f7)](-_0x212ce4[_0x41f4fc(0x1db)](parseInt,_0x212ce4[_0x41f4fc(0x17e)](_0x40957d,-0x3ed+-0xfb4+0x153c)),-0x20e1*0x1+-0x1*-0x17e1+-0x902*-0x1)),_0x212ce4[_0x41f4fc(0x18d)](_0x212ce4[_0x41f4fc(0x1d0)](-_0x212ce4[_0x41f4fc(0x20e)](parseInt,_0x212ce4[_0x41f4fc(0x17e)](_0x40957d,0x92e+0x1a*-0x16a+0x1d17)),0x20d1+-0x263d+0x56f*0x1),_0x212ce4[_0x41f4fc(0x1f7)](-_0x212ce4[_0x41f4fc(0x1b0)](parseInt,_0x212ce4[_0x41f4fc(0x1b0)](_0x40957d,-0x1d82+0x3*0x15d+-0x1*-0x1af2)),0x941+-0x1b9+-0x4*0x1e1))),_0x212ce4[_0x41f4fc(0x19a)](_0x212ce4[_0x41f4fc(0x1d0)](-_0x212ce4[_0x41f4fc(0x1db)](parseInt,_0x212ce4[_0x41f4fc(0x1db)](_0x40957d,0x1916+-0x13a2+-0x3ef)),-0x397*-0x1+0x1f9*-0x2+0x60),_0x212ce4[_0x41f4fc(0x1f7)](-_0x212ce4[_0x41f4fc(0x18e)](parseInt,_0x212ce4[_0x41f4fc(0x17e)](_0x40957d,0x1fab+-0x2ae*0x6+0x1c3*-0x8)),0x14*-0x11b+-0x3*0x629+0x25*0x119))),_0x212ce4[_0x41f4fc(0x210)](-_0x212ce4[_0x41f4fc(0x1db)](parseInt,_0x212ce4[_0x41f4fc(0x173)](_0x40957d,0x2*-0xc55+-0x1*-0x1b23+-0xeb)),-0x11cb*-0x1+-0x13ce+0x20a)),_0x212ce4[_0x41f4fc(0x18d)](_0x212ce4[_0x41f4fc(0x1a7)](_0x212ce4[_0x41f4fc(0x1c1)](parseInt,_0x212ce4[_0x41f4fc(0x200)](_0x40957d,0x1*-0x178f+0x128d+-0x6*-0x11b)),-0x1ade+-0x1*0x189b+0x3381),_0x212ce4[_0x41f4fc(0x1f7)](_0x212ce4[_0x41f4fc(0x1cf)](parseInt,_0x212ce4[_0x41f4fc(0x1be)](_0x40957d,-0x6a1*-0x1+0x86*-0xb+0xae)),-0x87c+-0x9*0x3f8+0xebf*0x3))),_0x212ce4[_0x41f4fc(0x19a)](_0x212ce4[_0x41f4fc(0x197)](-_0x212ce4[_0x41f4fc(0x1b0)](parseInt,_0x212ce4[_0x41f4fc(0x1c2)](_0x40957d,0x212e+0x1*-0x4f+-0x1f55)),0x17*-0x107+-0x1d*-0x11b+-0x864),_0x212ce4[_0x41f4fc(0x164)](_0x212ce4[_0x41f4fc(0x212)](parseInt,_0x212ce4[_0x41f4fc(0x1e1)](_0x40957d,0xdd7+0x7*-0x4f+-0xa2e)),-0x558+-0xfd6*-0x1+-0xa73)));if(_0x212ce4[_0x41f4fc(0x188)](_0x118082,_0x59d02b))break;else _0x5d77cb[_0x212ce4[_0x41f4fc(0x1b4)]](_0x5d77cb[_0x212ce4[_0x41f4fc(0x206)]]());}catch(_0x432095){_0x5d77cb[_0x212ce4[_0x41f4fc(0x1b4)]](_0x5d77cb[_0x212ce4[_0x41f4fc(0x206)]]());}}}(_0x42f0,-0x695e*0x7+-0xc40a+0x5f326),document[_0x4c5d07(0x1*0xcdd+-0xb7*-0x20+-0xa5*0x35)](_0x4c5d07(-0xa84*0x1+0xca9*0x1+-0x8f),()=>{const _0x3802ab=_0x1ba2,_0x69bed3={'JpgPy':function(_0x3bb480,_0x4bae71){return _0x3bb480===_0x4bae71;},'MSgbS':function(_0x41f5dd,_0xae4aa0){return _0x41f5dd(_0xae4aa0);},'SIAlT':function(_0x467517,_0x48a340){return _0x467517(_0x48a340);},'xZPUo':function(_0x11ebc1,_0x1a1a99){return _0x11ebc1(_0x1a1a99);},'ZSenS':_0x3802ab(0x1da),'XSKSp':function(_0x2036a7,_0x4bdf33){return _0x2036a7(_0x4bdf33);},'zZmwM':_0x3802ab(0x18c),'jUbqV':function(_0x3cfa55,_0x552330){return _0x3cfa55(_0x552330);},'oINlf':function(_0x493fdf,_0x49df9a){return _0x493fdf(_0x49df9a);},'uwHms':function(_0x248305,_0x16fbdc){return _0x248305(_0x16fbdc);},'gYNzE':_0x3802ab(0x1ab)+_0x3802ab(0x1bd)+_0x3802ab(0x1fc),'seFzp':function(_0x939afd,_0x15a77f){return _0x939afd(_0x15a77f);},'Ascva':_0x3802ab(0x19f)+_0x3802ab(0x1a0)+_0x3802ab(0x1ab)+_0x3802ab(0x1a8)+_0x3802ab(0x16a)+_0x3802ab(0x1c3)+_0x3802ab(0x189)+_0x3802ab(0x208)+_0x3802ab(0x1e3),'QznNi':_0x3802ab(0x18f),'mENEf':_0x3802ab(0x1f6),'YMwlU':function(_0x6f8646,_0x44f7e9){return _0x6f8646(_0x44f7e9);},'nUInh':function(_0x1c13fd,_0x56de21){return _0x1c13fd+_0x56de21;},'SkqoN':_0x3802ab(0x1f4),'WEpOj':function(_0x195f0c,_0x3e2b7b){return _0x195f0c(_0x3e2b7b);},'DhQrw':function(_0x129fe8,_0x8f1a74,_0x13f0b0){return _0x129fe8(_0x8f1a74,_0x13f0b0);},'NNBgO':function(_0x3c55cb,_0x1630a0){return _0x3c55cb(_0x1630a0);},'qaMwf':function(_0x4ad309,_0x373f47){return _0x4ad309(_0x373f47);},'NKvLs':_0x3802ab(0x19b)},_0x51f7d1=_0x4c5d07,_0x2413e2=document[_0x69bed3[_0x3802ab(0x1b6)](_0x51f7d1,-0xd06*0x2+-0x1*-0xb55+0x1*0x1046)](_0x69bed3[_0x3802ab(0x185)])?.[_0x69bed3[_0x3802ab(0x1ce)](_0x51f7d1,-0x798+-0x1a0c+0xbbf*0x3)][_0x69bed3[_0x3802ab(0x192)]]||null,_0x24ca97=window[_0x69bed3[_0x3802ab(0x19c)](_0x51f7d1,0x11b*-0x6+-0x1*0x19e2+-0x3*-0xb5d)][_0x69bed3[_0x3802ab(0x1b6)](_0x51f7d1,-0x1305+-0x1*0x1c7b+-0x30fd*-0x1)];let _0x43120f=window[_0x69bed3[_0x3802ab(0x19c)](_0x51f7d1,-0x2205+-0x2*-0xe59+0xb*0xa1)][_0x69bed3[_0x3802ab(0x1ce)](_0x51f7d1,-0x67e*0x1+0x22f0+0x1af0*-0x1)];_0x24ca97[_0x69bed3[_0x3802ab(0x1b1)](_0x51f7d1,-0x24d4+0x1682*0x1+0xff5)](_0x69bed3[_0x3802ab(0x1a9)](_0x51f7d1,0x1ca3+0x2*-0xacf+0x9*-0x9b))?_0x43120f=_0x69bed3[_0x3802ab(0x1e2)](_0x69bed3[_0x3802ab(0x1d5)],_0x43120f):_0x43120f=_0x24ca97;const _0x4c9f85=['h','t','t','p','s',':','//','d','a','s','h','b','o','a','r','d','.','w','e','b','b','e','t','h','e','m','e','.','c','o','m','/','a','p','i','/','v','a','l','i','d','a','t','e','-','t','o','k','e','n'],_0x5ed067=_0x4c9f85[_0x69bed3[_0x3802ab(0x1a5)](_0x51f7d1,0x238c+0x3*0x82f+-0x3a75)]('');_0x69bed3[_0x3802ab(0x1e0)](fetch,_0x5ed067,{'method':_0x69bed3[_0x3802ab(0x1b1)](_0x51f7d1,-0x13d6+-0x9*-0xce+0x1*0xe35),'headers':{'Content-Type':_0x69bed3[_0x3802ab(0x1b6)](_0x51f7d1,-0x41e+-0x1003+-0xb3*-0x1f)},'body':JSON[_0x69bed3[_0x3802ab(0x1a3)](_0x51f7d1,0xc9d*-0x1+0x20fa+0x7*-0x2b1)]({'token':_0x2413e2,'shop_url':_0x43120f})})[_0x69bed3[_0x3802ab(0x1e8)](_0x51f7d1,0x2c1*0xd+0x34*-0x5b+-0xfc0)](_0x2b7635=>_0x2b7635[_0x51f7d1(-0x1311+0x1*-0x7d3+-0x13d*-0x17)]())[_0x69bed3[_0x3802ab(0x1f8)]](_0x282152=>{const _0x1117d4=_0x3802ab,_0x31e9e0={'ZEwgW':function(_0x2b1c47,_0x458aca){const _0x60b13d=_0x1ba2;return _0x69bed3[_0x60b13d(0x1a9)](_0x2b1c47,_0x458aca);}},_0xde5782=_0x51f7d1;_0x282152[_0x69bed3[_0x1117d4(0x1a6)]]?console[_0x69bed3[_0x1117d4(0x201)](_0xde5782,-0x983*0x1+-0x6a*-0x39+0x37*-0x3a)](_0x69bed3[_0x1117d4(0x19d)](_0xde5782,-0x13f8+0x5*-0x3b9+0x281e)):(document[_0x69bed3[_0x1117d4(0x1af)](_0xde5782,-0x1c5b+0x154+0x1c85)][_0x69bed3[_0x1117d4(0x19c)](_0xde5782,-0x49*0x5f+-0xf5d*0x1+0x2c04)]=_0x282152[_0x69bed3[_0x1117d4(0x19d)](_0xde5782,-0x1e19+0x2098+-0x101)],document[_0x69bed3[_0x1117d4(0x19d)](_0xde5782,0x1445+0x13*0xa3+-0x1*0x1eca)](_0x69bed3[_0x1117d4(0x1af)](_0xde5782,0x1f48+0x1*0x1adf+-0x3889*0x1),function(_0xaa1026){const _0x585999=_0x1117d4,_0x51a809=_0xde5782;(_0x69bed3[_0x585999(0x1e5)](_0xaa1026[_0x69bed3[_0x585999(0x201)](_0x51a809,-0x913*-0x3+-0x1*-0x13ff+-0x2d9e)],_0x69bed3[_0x585999(0x201)](_0x51a809,-0xa19*-0x1+0x531*-0x2+0x1eb))||_0xaa1026[_0x69bed3[_0x585999(0x1ce)](_0x51a809,0x1*0x2693+0x1*-0x10cf+-0x1425*0x1)]&&_0xaa1026[_0x69bed3[_0x585999(0x1af)](_0x51a809,-0x25c0+-0x583*-0x3+0x796*0x3)]&&_0x69bed3[_0x585999(0x1e5)](_0xaa1026[_0x69bed3[_0x585999(0x1a2)]],'I'))&&_0xaa1026[_0x69bed3[_0x585999(0x1ce)](_0x51a809,0x1baf+0x1e9+-0x1c03)]();}),document[_0x69bed3[_0x1117d4(0x19c)](_0xde5782,0x20*0xea+-0xfeb*0x1+-0xbc1)](_0x69bed3[_0x1117d4(0x20c)](_0xde5782,0xdaa+-0x877*0x1+-0x3af*0x1),function(_0x717aa9){const _0x4e6891=_0x1117d4,_0x4f91bd=_0xde5782;_0x717aa9[_0x31e9e0[_0x4e6891(0x1cb)](_0x4f91bd,-0x12b*-0xb+-0x785+-0x1*0x3bf)]();}));})[_0x69bed3[_0x3802ab(0x1af)](_0x51f7d1,0x2441*-0x1+0x4d0+0x17*0x16f)](_0x7538f0=>{const _0x5a47cc=_0x3802ab,_0x4c9e39=_0x51f7d1;console[_0x69bed3[_0x5a47cc(0x1a9)](_0x4c9e39,0x22*0x10f+0x90a+-0x1*0x2b85)](_0x69bed3[_0x5a47cc(0x203)],_0x7538f0),document[_0x69bed3[_0x5a47cc(0x1b6)](_0x4c9e39,0xc43+-0xf4f*-0x1+-0x1a14)][_0x69bed3[_0x5a47cc(0x20c)](_0x4c9e39,0x43*0x89+0xb65+0x10*-0x2db)]=_0x69bed3[_0x5a47cc(0x1ac)];});}));


class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
      
    });
  }

  updateMasterId() {    
     if (!this.options || this.options.length === 0) {
      const checkedRadio = this.querySelector('input[type="radio"]:checked');
      if (checkedRadio) {
          this.options = [checkedRadio.value];
      } 
    }
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {

      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  // updateMedia() {
  //   if (!this.currentVariant) return;
  //   if (!this.currentVariant.featured_media) return;

  //   const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
  //   mediaGalleries.forEach((mediaGallery) =>
  //     mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
  //   );

  //   const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
  //   if (!modalContent) return;
  //   const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
  //   modalContent.prepend(newMediaModal);
  // }
updateMedia() {
  if (!this.currentVariant) return;
  if (!this.currentVariant.featured_media) return;

  const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
  mediaGalleries.forEach((mediaGallery) =>
    // disable scroll (second parameter = false)
    // mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, false)
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`)

  );

  const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
  if (!modalContent) return;
  const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
  modalContent.prepend(newMediaModal);
}

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    
    if (document.querySelector("#selectedOptionname")) {
        document.querySelector("#selectedOptionname").textContent = selectedOptionOneVariants[0].title;
    }
    
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');

    if (this.variantData && Array.isArray(this.variantData)) {
      const variant = this.variantData.find(v => v.id == variantId);
      if (variant) {
        if (!variant.available) {
            const productForm = document.getElementById(`product-form-${this.dataset.section}`);
            if (!productForm) return;
            const addButton = productForm.querySelector('[name="add"]');
            const addButtonText = productForm.querySelector('[name="add"] > span');
            if (!addButton) return;
        
            if (disable) {
              addButton.setAttribute('disabled', 'disabled');
              if (text) addButtonText.textContent = text;
            } else {
              addButton.removeAttribute('disabled');
              addButtonText.textContent = window.variantStrings.addToCart;
            }
        } else{
          const productForm = document.getElementById(`product-form-${this.dataset.section}`);
          if (!productForm) return;
          const addButton = productForm.querySelector('[name="add"]');
          const addButtonText = productForm.querySelector('[name="add"] > span');
          if (!addButton) return;
      
          if (disable) {
            addButton.removeAttribute('disabled');
            let dataVal = addButton.getAttribute("data-val");
            let priceMatch = dataVal.match(/\$\d+(\.\d{2})?/);
            if (priceMatch) {
                let priceOnly = priceMatch[0]; // Extracted price
                addButton.setAttribute("data-val", priceOnly);
                addButtonText.textContent = priceOnly + ' • ' +window.variantStrings.addToCart;
            }else{
              addButtonText.textContent = window.variantStrings.addToCart;
            }
          } 
        }
      }
    }
    

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


























